import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SaleLinkDTO, SaleLinkStatus, SaleLinkType } from '../../services/sale-link.service';

@Component({
  selector: 'app-sale-link-read',
  templateUrl: './sale-link-read.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class SaleLinkReadComponent {
  link = input.required<SaleLinkDTO>();

  typeLabel(type: SaleLinkType | undefined): string {
    if (type === 'REUSABLE') return 'Reutilizable';
    if (type === 'SUBSCRIPTION') return 'Suscripción';
    return 'Pago único';
  }

  statusLabel(status: SaleLinkStatus | undefined): string {
    if (status === 'PAID') return 'Pagada';
    if (status === 'CANCELLED') return 'Cancelada';
    if (status === 'EXPIRED') return 'Vencida';
    if (status === 'ACTIVE') return 'Activa';
    return status ?? '—';
  }

  frequencyLabel(frequency: string | undefined): string {
    const labels: Record<string, string> = {
      DAILY: 'Diaria',
      WEEKLY: 'Semanal',
      BIWEEKLY: 'Quincenal',
      MONTHLY: 'Mensual',
      QUARTERLY: 'Trimestral',
      SEMIANNUALLY: 'Semestral',
      ANNUALLY: 'Anual'
    };
    return frequency ? labels[frequency] ?? frequency : '—';
  }

  statusIcon(status: SaleLinkStatus | undefined): string {
    if (status === 'PAID') return 'pi pi-check';
    if (status === 'CANCELLED') return 'pi pi-times';
    if (status === 'EXPIRED') return 'pi pi-clock';
    return 'pi pi-link';
  }

  statusIconClasses(status: SaleLinkStatus | undefined): string {
    const base = 'h-7 w-7 rounded-full flex items-center justify-center';
    if (status === 'PAID') return `${base} bg-emerald-100 text-emerald-600`;
    if (status === 'ACTIVE') return `${base} bg-sky-100 text-sky-600`;
    if (status === 'EXPIRED') return `${base} bg-amber-100 text-amber-600`;
    if (status === 'CANCELLED') return `${base} bg-slate-200 text-slate-600`;
    return `${base} bg-slate-100 text-slate-600`;
  }

  hasNotes(notes: string | undefined): boolean {
    if (!notes) return false;
    return notes.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length > 0;
  }

  lineAmount(quantity: number | undefined, unitPrice: number | undefined): number {
    return (quantity ?? 0) * (unitPrice ?? 0);
  }
}
